// extracted by mini-css-extract-plugin
export default {"spinner":"Spiner_spinner__dTTq3","spinnerWraper":"Spiner_spinnerWraper__xv6C9"};